<template>
<div class="chapter">
<div class="inner_page">
<p class="prelim-heading">Dedication</p>
<p class="body-text-full-out body-text-full-out-override mtop1"><span class="no-style-override-16">Lest we forget the suffering these beasts of humanity </span></p>
<p class="body-text-full-out body-text-full-out-override"><span class="no-style-override-16">cause, this book is dedicated in memory of:</span></p>
<p class="body-text body-text-override-2 mtop1"><span class="no-style-override-16">Leanna Williams (died 23 August 1994)</span></p>
<p class="body-text-full-out mtop1">Now on Death Row, Ellis Unit, Texas, Santiago Margarito Rangel Varelas (#999159) is a revolting human monster even when viewed alongside the rebarbative exploits of other killers of our children. His victim was Leanna Williams, his two-year-old stepdaughter. Varelas had been married to Leanna’s mother for less than four months when the child died. But during that short time he had carried out an unrelenting barrage of violence and sexual abuse on the infant; the violence alone would have been enough to kill a healthy adult, and this started almost immediately after the wedding.</p>
<p class="body-text"><span class="no-style-override-17">Leanna died of multiple brain haemorrhages after repeated kicks to the head. Most of her ribs were broken and she had been sodomised. Varelas told police that the child had fallen inside their home at 4415 2nd Street in Bacliff, Texas. However, it is even almost as repugnant and difficult to believe that Leanna’s mother told sickened investigators that she was unaware of what was going on, especially since Varelas was also indicted on charges of indecency involving Leanna’s sisters aged five and nine.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f005.vue?5200b4e4